module.exports = __webpack_public_path__ + "img/big_1_46.9835bd9c.png";